import React, { type FC } from 'react';

export const FlameSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path d="M12.3346 9.33333C12.3346 11.6667 10.5786 13.6667 8.0013 13.6667C5.42397 13.6667 3.66797 11.6667 3.66797 9.33333C3.66797 8.13889 4.33464 6.33333 6.0013 5.33333C6.0013 7.33333 6.0013 9.2 7.33464 8.66667C9.13641 7.94596 5.33464 4.66667 8.0013 2C9.33464 6.33333 12.3346 6 12.3346 9.33333Z" />
        </svg>
    );
};
